import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import searchAtomPair from 'atoms/search-atom';
import type {
  RoyaltyCheckDetailResponse,
  RoyaltyCheckLineItem,
  RoyaltyCheckLineItemsSearchParams,
} from './types';

const useRoyaltyCheckAtom = (id: string) =>
  useMemo(
    () =>
      createResourceAtom<RoyaltyCheckDetailResponse>(`/royalty_checks/${id}`),
    [id]
  );

// Server-driven line items: paginate/sort/filter/search on the backend via
// Query::RoyaltyCheckLineItems (nested inner_hits over the check's denormalized
// line_items in Elasticsearch), instead of pulling the whole set into the browser.
const useRoyaltyCheckLineItemsSearchAtom = (royaltyCheckId: string) =>
  useMemo(
    () =>
      searchAtomPair<RoyaltyCheckLineItem, RoyaltyCheckLineItemsSearchParams>({
        href: `/royalty_checks/${royaltyCheckId}/queries/line_items`,
      }),
    [royaltyCheckId]
  );

export { useRoyaltyCheckAtom, useRoyaltyCheckLineItemsSearchAtom };
